import React, { useEffect, useState } from 'react'
import { RestContext } from './context';
import { Gala } from '../../services/service-gala'
import { NQC } from '../../services/service-nqc'
import { useConfig } from '../config/use'
import * as dayjs from 'dayjs'
import qs from 'qs'
import { useHistory, useLocation } from "react-router-dom"
import { geodistance } from '../../components/helpers/geographic_distance'
import { OfficeInfo } from '../../services/dto/officeinfo.dto';
import { isFalsyOrEmpty } from '../../components/helpers/object'
import axios from 'axios'

export const RestProvider = ({children}) => {
  const { state: { config }, actions: { Queuefilter, GetResources, GetPrinterData, UpdateQueueDataFromConfig, GetQueuenameFromQueueID, OfficeFilter, IsOfficeActive, GetUrlIDFromOfficeID, GetUrlIDFromQueueID, GetCheckinData }} = useConfig();
  const [service, setService] = useState();
  const [offices, setOffices] = useState(null);
  const [selectedoffice, setSelectedOfficeID] = useState();
  const [ticket, setTicket] = useState(null);
  const [shouldCancelTicket, setShouldCancelTicket] = useState(false);
  const [queues, setQueues] = useState(null);
  const [searchfilter, setSearchFilter] = useState("");
  const [selectedqueuename, setSelectedQueueName] = useState();
  const [ticketupdatetimeout, setTicketUpdateTimeout] = useState();
  const [queuesupdatetimeout, setQueuesUpdateTimeout] = useState();
  const [wasticketfailure, setWasTicketFailure] = useState(false);
  const history = useHistory();
  const location = useLocation();

  // Step 1: Load previous data from local storage
  useEffect(() => {
    let ticket = {}
    let seloffice = null;
    try
    {
      ticket = JSON.parse(localStorage.getItem("ticket"));
      if (isFalsyOrEmpty(ticket))
        ticket = {}
    } catch(error) { console.debug(error) }

    try
    {
      seloffice = localStorage.getItem("selectedoffice");
      if (isFalsyOrEmpty(seloffice))
        seloffice = null;
    } catch(error) { console.debug(error) }
    // If ticket is older than today 0:01 then mark it as ended
    if (!isFalsyOrEmpty(ticket) && isOlderThanToday(ticket.timestamp))
    {
      setShouldCancelTicket(true);
      ticket = {}
    }
      
    localStorage.setItem("ticket", JSON.stringify(ticket));
    setSelectedQueueName(localStorage.getItem("selectedqueuename"));
    setSelectedOfficeID(seloffice);
    setTicket(ticket);  
    PeriodicConfigUpdate();
  },[])

  // Step 2: Ensure config file is loaded from Config context
  useEffect(() => {
    if (config)
    {
      setService(getServiceFromConfig());
      setAuthToken(localStorage.getItem("selectedoffice"));
    }
  }, [config]);

  // Step 3: Make sure service has been generated, then populate offices
  useEffect(() => {
    if (service)
    {
      if (shouldCancelTicket === true)
      {
        handleCancelTicket(ticket);
        setShouldCancelTicket(false);
      }
      GetAllOffices();
      if (!ticketupdatetimeout)
        PeriodicTicketUpdate();
      if (!queuesupdatetimeout)
        PeriodicQueueUpdate();
    }
  }, [service])

  // When we change location, start/stop relevant services.
  useEffect(() => {
    if (location.pathname === "/queues")
    {
      localStorage.setItem("updateQueues", true);
      localStorage.removeItem("updateTicket");
      clearTimeout(ticketupdatetimeout);
      clearTimeout(queuesupdatetimeout);
      if (config && service)
        PeriodicQueueUpdate();
    }
    else if (location.pathname === "/ticket")
    {
      localStorage.setItem("updateTicket", true);
      localStorage.removeItem("updateQueues");
      clearTimeout(queuesupdatetimeout);
      clearTimeout(ticketupdatetimeout);
      if (config && service)
        PeriodicTicketUpdate();
    }
    else
    {
      localStorage.removeItem("updateTicket");
      localStorage.removeItem("updateQueues");
      clearTimeout(ticketupdatetimeout);
      clearTimeout(queuesupdatetimeout);
    }
  }, [location])

  async function GetAllOffices() {
    if(isFalsyOrEmpty(offices))
    {
      const updatedOffices = await service.getAllOffices();
      const filteredOffices = await OfficeFilter(updatedOffices);
      if (!isFalsyOrEmpty(selectedoffice))
      {
        var result = IsOfficeActive(selectedoffice);
        if (result === false)
        {
          setSelectedOfficeID("");
          localStorage.removeItem(selectedoffice);
        }
      }
      setOffices(filteredOffices);
    }
  }

  const PeriodicConfigUpdate = async () => {
    let timeout = config ? config.updateconfigtimer : 60000;
    await GetResources();

    const timer = setTimeout(() => {
      PeriodicConfigUpdate();
    }, timeout)
  }

  const PeriodicTicketUpdate = async () => {
    let run = localStorage.getItem("updateTicket");
    let lsticket = JSON.parse(localStorage.getItem("ticket"));
    let tmpTicket;
    if(lsticket && !isFalsyOrEmpty(lsticket) && !lsticket.cancelled && service && config && run)
    {
      tmpTicket = await service.getIndividualTicketInfo(lsticket.ticketID);
      run = localStorage.getItem("updateTicket");
      if (tmpTicket)
      {
        if (run)
        {
          tmpTicket.timestamp = dayjs(tmpTicket.timestamp).format(config.dateformat);
          setTicket(tmpTicket);
          localStorage.setItem("ticket", JSON.stringify(tmpTicket));
        }
      }
      else
      {
        //TODO: Vi har fått tillbaka null, kanske förklara för kunden att vi inte lyckades hämta data
        var errorticket = JSON.parse(localStorage.getItem("ticket"));
        if (isFalsyOrEmpty(errorticket))
          handleCancelTicket();
      }
    }
    let timeoutArray = config ? config.updatetimers : [];
    let timeout = 15000;
    let configuredtimeobject = null;
    if (!isFalsyOrEmpty(timeoutArray) && !isFalsyOrEmpty(tmpTicket))
    {
      if(!tmpTicket.meetUpLocation)
      {
        configuredtimeobject = timeoutArray.find(x => x.length <= parseInt(tmpTicket.peopleAhead));
        timeout = (configuredtimeobject && tmpTicket) ? configuredtimeobject.seconds : 15000;
      }
    }
    
    setTicketUpdateTimeout(setTimeout(() => { 
      PeriodicTicketUpdate();
    }, timeout ));
  }

  const PeriodicQueueUpdate = async () => {
    let run = localStorage.getItem("updateQueues");
    let queuetimeout = config ? config.updatequeuetimer : 15000;
    var seloffice = localStorage.getItem("selectedoffice");
    if (seloffice && run)
      await GetQueues(seloffice);
    setQueuesUpdateTimeout(setTimeout(() => { 
      PeriodicQueueUpdate();
    }, queuetimeout ));
  }
  

  // Callback function to set selected office
  const handleOfficeSelection = async (officeID) => {
      setAuthToken(officeID);
      setSelectedOfficeID(officeID);
      localStorage.setItem("selectedoffice", officeID);
      GetQueues(officeID);
      history.push("queues?officeID="+ GetUrlIDFromOfficeID(officeID));
  }

  const handleGeolocationUpdate = () => {
    if(navigator.geolocation)
    {
      navigator.geolocation.getCurrentPosition((position) => {
        var distanceList = offices.map(x => { return new OfficeInfo(x.name, x.officeID, x.address.street, x.address.city, x.address.zipcode, x.address.geolocation.lat, x.address.geolocation.lng, geodistance(x.address.geolocation.lat, x.address.geolocation.lng, position.coords.latitude, position.coords.longitude, config.distanceUnit), x.phone)});
        var sortedList = distanceList.sort((a,b) => (a.distance - b.distance));
        setOffices(sortedList);
        sessionStorage.setItem("offices", JSON.stringify(sortedList));
      }, 
      () => {
        // TODO: Berätta för användaren att de inte kan få information som baseras på geodata
        // TODO: Kanske fixa en konverterar-funktion som tar bort / lägger till distance till officedata?
      },
      { maximumAge: 120000, timeout: 2000 })
    }
  }

  const handleTakeTicket = (officeID, queuedata, svc, customertext) => {
    async function TakeTicket(officeID, queuedata) {
      var ticketID;
      var tmpTicket;
      let printerdata;

      if (!isFalsyOrEmpty(svc))
      {
        printerdata = await GetPrinterData(officeID);
        if (!isFalsyOrEmpty(printerdata))
        {
          ticketID = await svc.grabATicket(queuedata, officeID, customertext, printerdata.printerNumber, printerdata.printerTextNumber );
          if (ticketID)
          {
            for(var i = 0; i < 5; i++)
            {
              await new Promise(r => setTimeout(r, 300));
              tmpTicket = await svc.getIndividualTicketInfo(ticketID);
              if (!isFalsyOrEmpty(tmpTicket))
              {
                tmpTicket.timestamp = dayjs(tmpTicket.timestamp).format(config.dateformat);
                break;
              }
            }
          }
          else
            setWasTicketFailure(true);
        }
      }
      else
      {
        printerdata = await GetPrinterData(officeID);
        if (!isFalsyOrEmpty(printerdata))
        {
          ticketID = await service.grabATicket(queuedata, officeID, customertext, printerdata.printerNumber, printerdata.printerTextNumber );
          if (ticketID)
          {
            for(var j = 0; j < 5; j++)
            {
              await new Promise(r => setTimeout(r, 300));
              tmpTicket = await service.getIndividualTicketInfo(ticketID);
              if (!isFalsyOrEmpty(tmpTicket))
              {
                tmpTicket.timestamp = dayjs(tmpTicket.timestamp).format(config.dateformat);
                break;
              }
            }
          }
          else
            setWasTicketFailure(true);
        }
      }

      if (!isFalsyOrEmpty(tmpTicket))
      {
        var queuename;
        if (queues)
        {
          var res = queues.find(x => x.queueID === queuedata.queueID);
          queuename = res ? res.name : null;
        }
        else
        {
          const filteredqueues = await GetQueues(officeID, svc); 
          const res = filteredqueues.find(x => x.queueID === queuedata.queueID);
          queuename = res ? res.name : null;
        }
        if (!isFalsyOrEmpty(queuename))
        {
          setTicket(tmpTicket);
          localStorage.setItem("ticket", JSON.stringify(tmpTicket));
          localStorage.setItem("selectedqueuename", GetQueuenameFromQueueID(officeID, queuedata.queueID));
          localStorage.setItem("selectedqueue", queuedata.queueID);
          setSelectedQueueName(queuename);
          sessionStorage.setItem("queuename", queuename);
          var oid = GetUrlIDFromOfficeID(officeID);
          var qid = GetUrlIDFromQueueID(officeID, queuedata.queueID);
          history.push("ticket?officeID=" + oid + "&queueID=" + qid);
        }
        else
          setWasTicketFailure(true);
      }
      else
      {
        localStorage.removeItem("tickettext");
        setWasTicketFailure(true);
      }
    }

    if (!isFalsyOrEmpty(config))
      TakeTicket(officeID, queuedata, svc);
  }
  
  const handleTakeBookedTicket = (eticketBooking, customertext, printernumber, svc) => {
    async function TakeTicket() {
      var ticketID;
      var tmpTicket;

      if (!isFalsyOrEmpty(svc))
      {
        ticketID = await svc.getBookedTicket(eticketBooking, customertext, printernumber);
        if (ticketID)
        {
          for(var i = 0; i < 5; i++)
          {
            await new Promise(r => setTimeout(r, 300));
            tmpTicket = await svc.getIndividualTicketInfo(ticketID);
            if (!isFalsyOrEmpty(tmpTicket))
            {
              tmpTicket.timestamp = dayjs(tmpTicket.timestamp).format(config.dateformat);
              break;
            }
          }
        }
        else
          setWasTicketFailure(true);
      }
      else
      {
        ticketID = await service.getBookedTicket(eticketBooking, customertext, printernumber);
        if (ticketID)
        {
          for(var j = 0; j < 5; j++)
          {
            await new Promise(r => setTimeout(r, 300));
            tmpTicket = await service.getIndividualTicketInfo(ticketID);
            if (!isFalsyOrEmpty(tmpTicket))
            {
              tmpTicket.timestamp = dayjs(tmpTicket.timestamp).format(config.dateformat);
              break;
            }
          }
        }
        else
          setWasTicketFailure(true);
      }

      if (!isFalsyOrEmpty(tmpTicket))
      {
          CheckinTicketInVentus(eticketBooking);
          setTicket(tmpTicket);
          localStorage.setItem("ticket", JSON.stringify(tmpTicket));
          var oid = GetUrlIDFromOfficeID(localStorage.getItem("selectedoffice"));
          var qid = GetUrlIDFromQueueID(localStorage.getItem("selectedoffice"), localStorage.getItem("selectedqueue"));
          history.push("ticket?officeID=" + oid + "&queueID=" + qid);
      }
      else
      {
        localStorage.removeItem("tickettext");
        setWasTicketFailure(true);
      }
    }

    if (!isFalsyOrEmpty(config))
      TakeTicket(svc);
  }

  const CheckinTicketInVentus = async (eticketBooking) => {
    var checkindata = GetCheckinData(localStorage.getItem("selectedoffice"));
    await axios.get(config.soapmiddlewareurl + "Checkin/?bookingNumber=" + eticketBooking.bookingNumber + 
    "&orgId=" + checkindata.ventusOrgNumber +
    "&sectionId=" + checkindata.ventusSection)
    .then(res => {
      //localStorage.setItem("checkedin", true);
    })
  }

  const handleCancelTicket = (ticketID) => {
    localStorage.removeItem("updateTicket");
    localStorage.removeItem("selectedqueuename");
    localStorage.removeItem("selectedqueue"); 
    localStorage.removeItem("ticket");
    sessionStorage.setItem("queuename", "");
    localStorage.removeItem("tickettext");
    setSelectedQueueName(null);
    if (ticketID)
      service.cancelTicket(ticketID);
    else if (ticket && ticket.ticketID)
      service.cancelTicket(ticket.ticketID);
    setTicket(null);
    setSelectedQueueName("");
    var selected = selectedoffice;
    if (!selected)
      selected = localStorage.getItem("selectedoffice");
    if (selected)
      history.push("queues")
    else if (config && config.uselandingpage)
      history.push("/")
  }

  const handleChangeOffice = () => {
    sessionStorage.removeItem("formdata");
    setSelectedOfficeID(null);
    sessionStorage.setItem("queues", null);
    setQueues(null);
    sessionStorage.setItem("queuename", "");
    setSelectedQueueName("");
    localStorage.setItem("selectedoffice", "");
    history.push("/");
  }


  // Helper functions, refactor when possible
  const isOlderThanToday = (timestamp) => {
    var year = dayjs().year()
    var month = dayjs().month() + 1
    var date =  dayjs().date()
    var datastring = year + "-" + month + "-" + date;
    return dayjs(timestamp).isBefore(String(datastring));
  }

  const isOlderThanMinutes = (timestamp, minutes) => {
    return dayjs(timestamp).isBefore(String(dayjs().subtract(minutes, 'minutes')));
  }

  const getServiceFromConfig = () => {
    if (config)
    {
      if (config.provider === "Gala")
        return new Gala(config.baseurl);
      else if (config.provider === "NQC")
        return new NQC(config.baseurl);
    }
    else
      return null;
  }

  const setAuthToken = guid => {

    if (config)
    {
      if (config.provider === "Gala")
      {
        sessionStorage.tokenconfig = ""
      }
      else if (config.provider === "NQC" && guid)
      {
        sessionStorage.tokenconfig = JSON.stringify({   
          method: 'post',
          url: 'oauth2/token',
          baseURL: config.baseurl,
          data: qs.stringify({
            officeguid: guid,
            grant_type: 'password',
            client_id: '099153c2625149bc8ecb3e85e03f0022'
          }),
          headers: {
            'content-type' : 'application/x-www-form-urlencoded'
          },
        })
      }
    }
  }

  const updateSearchFilter = (filter) => {
    setSearchFilter(filter);
  }

  async function GetQueues(officeID, svc = null) {
    var tmpqueues;
    if (svc)
      tmpqueues = await svc.getAvailableQueuesForSelectedOffice(officeID, config.servicetimeout);
    else
      tmpqueues = await service.getAvailableQueuesForSelectedOffice(officeID, config.servicetimeout);
    const renamedqueues = UpdateQueueDataFromConfig(officeID, tmpqueues);
    const filteredqueues = await Queuefilter(officeID, renamedqueues);
    setQueues(filteredqueues);
    sessionStorage.setItem("queues", JSON.stringify(filteredqueues));
    return filteredqueues;
  }

  // Redirects
  const qrToQueueSelection = async (officeID) => {
      const svc = getServiceFromConfig();
      setService(svc);
      svc.getAllOffices();
      setSelectedOfficeID(officeID);
      localStorage.setItem("selectedoffice", officeID);
      setAuthToken(officeID);
      await GetQueues(officeID, svc);
  }

  const qrToCheckinSelection = async (officeID) => {
    const svc = getServiceFromConfig();
    setService(svc);
    svc.getAllOffices();
    setSelectedOfficeID(officeID);
    localStorage.setItem("selectedoffice", officeID);
    setAuthToken(officeID);
    await GetQueues(officeID, svc);
  }

  const qrToFormsSelection = async (officeID, queuedata) => {
    const svc = getServiceFromConfig();
    setService(svc);
    svc.getAllOffices();
    setSelectedOfficeID(officeID);
    localStorage.setItem("selectedoffice", officeID);
    localStorage.setItem("selectedqueue", queuedata.queueID);
    localStorage.setItem("selectedqueuename", GetQueuenameFromQueueID(officeID, queuedata.queueID));
    setAuthToken(officeID);
    await GetQueues(officeID, svc);
  }

  const qrToDirectTicket = async (officeID, queuedata, customertext ) => {
    // TODO: Handle if queueID is undefined or if segmentID and serviceID is undefined.
    const svc = getServiceFromConfig();
    setService(svc);
    svc.getAllOffices();
    setSelectedOfficeID(officeID);
    localStorage.setItem("selectedoffice", officeID);
    localStorage.setItem("selectedqueue", queuedata.queueID);
    setAuthToken(officeID);
    var filteredqueues = await GetQueues(officeID, svc);
    if (filteredqueues.some(x => x.queueID === queuedata.queueID))
      handleTakeTicket(officeID, queuedata, svc, customertext);
    else
    {
      localStorage.setItem("selectedqueue", null);
      history.push("queues");
    }
  }

  const toExistingTicket = (ticket) => {
    if (!isOlderThanToday(ticket.timestamp) && !ticket.cancelled)
      history.push("ticket")
  }

  const resetTicketFailureStatus = () => {
    setWasTicketFailure(false);
  }


  const value = {
    state: {offices, selectedoffice, queues, selectedqueuename, ticket, service, searchfilter, wasticketfailure },
    actions: {handleOfficeSelection, handleChangeOffice, handleTakeTicket, handleGeolocationUpdate, handleCancelTicket, qrToQueueSelection, qrToCheckinSelection, qrToDirectTicket,qrToFormsSelection, toExistingTicket, updateSearchFilter, resetTicketFailureStatus, handleTakeBookedTicket }
  }

  return (
    <RestContext.Provider value={value}>
      <div className="custom_background_div"
      style={ 
        config ?
        {  
          backgroundImage: "url(" + process.env.PUBLIC_URL + config.custombackgroundlink + ")", backgroundPosition: 'center',
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
          height: '100%',
          width: '100%',
          display: 'flex',
          flexDirection: 'column'
        }
        : {}
      }>
        { children }
      </div>
    </RestContext.Provider>
  )
}